module.exports = __webpack_public_path__ + "img/Serbia.91cc9558.png";